import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { selectStyle } from '../../static-data/configDropdownOptions';

const MultiSelect = ({
  options = [],
  selectedValues = [],
  maxSelections,
  placeholder = 'Select items',
  onChange,
  disabled = false,
  sx = {},
  menuProps = {},
  showSelectAll = false,
  renderOption,
}) => {
  const handleChange = (event) => {
    const value = event.target.value;
    if (value.includes('all')) {
      onChange(selectedValues.length === options.length ? [] : options);
    } else {
      onChange(value);
    }
  };

  const renderValue = (selected) => {
    if (selected.length === 0)
      return <span style={{ color: '#888' }}>{placeholder}</span>;
    if (selected.includes('all')) {
      return 'All selected';
    }
    return selected.join(', ');
  };
  const isAllSelected = selectedValues.length === options.length;

  return (
    <FormControl sx={{ width: '100%', mb: 2, ...sx }} disabled={disabled}>
      <Select
        multiple
        sx={selectStyle}
        IconComponent={KeyboardArrowDownIcon}
        value={selectedValues}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={renderValue}
        displayEmpty
        MenuProps={menuProps}>
        {showSelectAll && (
          <MenuItem value="all">
            <Checkbox checked={isAllSelected} />
            <ListItemText primary="Select All" />
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            disabled={
              maxSelections !== undefined &&
              !selectedValues.includes(option) &&
              selectedValues.length >= maxSelections
            }>
            <Checkbox
              disabled={
                maxSelections !== undefined &&
                !selectedValues.includes(option) &&
                selectedValues.length >= maxSelections
              }
              disableRipple
              checked={selectedValues.includes(option)}
            />
          <ListItemText 
           primary={
           renderOption ? (                    
          renderOption(option)
          ) : (
           <span style={{ textTransform: 'none' }}>{option}</span>
          )
          } 
         />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
